;(function ($) {


  $(document).ready(function () {
    // Main Dropdown menu hacks to make it accessible
    $('body').on('focus', '[data-dropdown-submenu-toggle]', dropdownSubmenuOpenAria);
    $('body').on('blur', '[data-dropdown-submenu-toggle]', dropdownSubmenuCloseAria);
    $('body').on('blur', '.is-submenu-item', blurDropdownSubmenuItem);
    initMainMenuA11y();
  });

  /**
   * Setup the Main dropdown menu, remove aria-popup, add aira-controls, the ids for the submenus add aria-expanded.
   */
  function initMainMenuA11y() {
    let mainMenu = $('#main_dropdown_menu'),
      lisWithSubmenus = mainMenu.find('.is-dropdown-submenu-parent');

    lisWithSubmenus.each(function (index) {
      let $this = $(this),
        button = $this.find('button'),
        submenu = $this.find('.submenu');
      $this.removeAttr('aria-haspopup');
      $this.removeAttr('aria-label');
      button.attr('aria-expanded', 'false');
      button.attr('aria-controls', index + '_submenu');
      submenu.attr('id', index + '_submenu');
    });

  }

  /**
   * Adds the extra dropdown menus logic for keyboard accessibility when focusing
   * @param e
   */
  function dropdownSubmenuOpenAria(e) {
    let $this = $(this),
      parentLi = $this.parent('li'),
      submenu = parentLi.find('.submenu');
    parentLi.addClass('is-active');
    submenu.addClass('js-dropdown-active');
    $this.attr('aria-expanded', 'true');

  }

  /**
   * Adds the extra dropdown menu logic keyboard accessibility when focusing out
   * @param e
   */
  function dropdownSubmenuCloseAria(e) {
    let $this = $(this),
      parentLi = $this.parents('.is-dropdown-submenu-parent'),
      parentButton = parentLi.find('button'),
      submenu = parentLi.find('.submenu');
    if (e.relatedTarget !== null) {
      let parentLiClass = e.relatedTarget.parentElement.classList.contains('is-dropdown-submenu-item');
      if (!parentLiClass) {
        parentLi.removeClass('is-active');
        submenu.removeClass('js-dropdown-active');
        parentButton.attr('aria-expanded', 'false');
      }
    }
  }

  /**
   * Closes the dropdown menu focusing out of of it and handles the aria-expanded logic.
   * @param e
   */
  function blurDropdownSubmenuItem(e) {
    let $this = $(this);
    if (e.relatedTarget !== null) {
      let parentLiClass = e.relatedTarget.parentElement.classList.contains('is-dropdown-submenu-item');
      if (parentLiClass) {
        return;
      } else {
        let parentLi = $this.parents('.is-dropdown-submenu-parent'),
          parentButton = parentLi.find('button');
        submenu = $this.parent('.submenu');
        parentLi.removeClass('is-active');
        submenu.removeClass('js-dropdown-active');
        parentButton.attr('aria-expanded', 'false');
      }
    }
  }
  
})(jQuery);
